var React = require('react');

function IconMail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.21761 7.28214C5.7682 6.96113 5.14365 7.06522 4.82264 7.51463C4.50163 7.96404 4.60572 8.58859 5.05513 8.9096L11.4188 13.4551C11.7665 13.7034 12.2336 13.7034 12.5812 13.4551L18.9449 8.9096C19.3943 8.58859 19.4984 7.96404 19.1774 7.51463C18.8564 7.06522 18.2318 6.96113 17.7824 7.28214L12 11.4124L6.21761 7.28214Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5 3.5C2.61438 3.5 1 5.11438 1 7.5V16.5C1 18.8856 2.61438 20.5 5 20.5H19C21.3856 20.5 23 18.8856 23 16.5V7.5C23 5.11438 21.3856 3.5 19 3.5H5ZM3 7.5C3 6.21895 3.71895 5.50199 5 5.50199H19C20.281 5.50199 21 6.21895 21 7.5V16.5C21 17.781 20.281 18.5 19 18.5H5C3.71895 18.5 3 17.781 3 16.5V7.5Z","fill":"currentColor","key":1})]);
}

IconMail.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconMail;

IconMail.default = IconMail;
